import {countryCodes} from '../../options/countryCodes';

// Sort country code objects in ascending order of codes
const getSortedCountryCodes = () => countryCodes.sort((a, b) => a.value - b.value);

export default getSortedCountryCodes;
